import { usePropertiesGetLocationIds } from '../../../Hooks/usePropertiesGetLocationIds';
import { LocationVarKey } from '@swivl-mono/types';
import {TextRow, Indent, InputRow, TextAreaRow, DropdownRow, MultiLineRow, SwitchRow, SectionHeader, PageHeader, Section } from '../../../Components/Worksheets/WorksheetComponent/WorksheetComponents';
import { IS_NOT_EQUAL, IS_EQUAL, IS_TRUE, IF_ANY } from '../../../Components/Worksheets/Types/Worksheet.Interface';

export default  function WorksheetView() {
    const page = usePropertiesGetLocationIds();  
  return  <>
        <PageHeader {...page} 
        subheading=""
        > Size Visuals</PageHeader>
        
        <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasSizeGuideURL, "1")}>
        <SwitchRow {...page}  keyName= {LocationVarKey.AfterNavigateSizeVisuals} label="Ask if they want to be navigated to your Size Guide URL"/>
        <Section {...page} hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.AfterNavigateSizeVisuals, "1"), IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")])}>
        <SectionHeader {...page} > After Navigate</SectionHeader>
        <TextAreaRow {...page}   
            marginTop
            label=" Message 1"
            keyName= {LocationVarKey.AfterNavigateSizeVisuals1}
        />
        <TextAreaRow {...page} 
            marginTop
            label=" Message 2 (Optional)"
            keyName= {LocationVarKey.AfterNavigateSizeVisuals2}
            enableSwitchVar={LocationVarKey.AfterNavigateSizeVisuals2Enabled}
        />
        </Section>
        </Section>
    </>
}